import { render } from "./BarChartHorizontal.vue?vue&type=template&id=61c1f1b6"
import script from "./BarChartHorizontal.vue?vue&type=script&lang=js"
export * from "./BarChartHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__